import { render, staticRenderFns } from "./attr-class.vue?vue&type=template&id=6e3f9334&"
import script from "./attr-class.vue?vue&type=script&lang=js&"
export * from "./attr-class.vue?vue&type=script&lang=js&"
import style0 from "./attr-class.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports